import TextMessageRecord from "./TextMessageRecord";
import { ConditionalMessageRecord } from "./ConditionalMessageRecord";
import { ScheduledBlockRecord } from "./ScheduledBlockRecord";
import ZendeskAgentWorkspaceHandoffMessageRecord from "./ZendeskAgentWorkspaceHandoffMessageRecord";
import AuthMessageRecord from "./AuthMessageRecord";
import DeauthMessageRecord from "./DeauthMessageRecord";

export { default as AdaMessengerMessageRecord } from "./AdaMessengerMessageRecord";
export { default as AuthMessageRecord } from "./AuthMessageRecord";
export { default as BookMeetingMessageRecord } from "./BookMeetingMessageRecord";
export { default as BotSwitchMessageRecord } from "./BotSwitchMessageRecord";
export { default as CaptureMessageRecord } from "./CaptureMessageRecord";
export {
  default as ConditionalMessageRecordCreator,
  ConditionalMessageRecord,
  ConditionalRecord,
  ConditionalStatement
} from "./ConditionalMessageRecord";
export { default as CsatMessageRecord } from "./CsatMessageRecord";
export { default as QuickRepliesMessageRecord, QuickRepliesMessageRecordQuickReply } from "./QuickRepliesMessageRecord";
export { default as CustomHandoffEventMessageRecord } from "./CustomHandoffEventMessageRecord";
export { default as DeauthMessageRecord } from "./DeauthMessageRecord";
export { default as HandoffMessageRecord } from "./HandoffMessageRecord";
export { default as HandoffRecipeMessageRecord } from "./HandoffRecipeMessageRecord";
export { default as HTTPMessageRecord } from "./HTTPMessageRecord";
export { default as LinkMessageRecord } from "./LinkMessageRecord";
export { default as ListSelectionRecord } from "./ListSelectionRecord";
export { default as LiveHandoffMessageRecord } from "./LiveHandoffMessageRecord";
export { default as LivepersonChatHandoverRecord } from "./LivepersonChatHandoverRecord";
export { default as JavascriptEventMessageRecord } from "./JavascriptEventMessageRecord";
export { default as PictureMessageRecord } from "./PictureMessageRecord";
export { default as ReCaptchaRecord } from "./ReCaptchaRecord";
export { default as RedirectRecord } from "./RedirectRecord";
export { default as SalesforceMessageRecord } from "./SalesforceMessageRecord";
export { default as SalesforceLiveAgentMessageRecord } from "./SalesforceLiveAgentMessageRecord";
export { default as SatisfactionSurveyMessageRecord } from "./SatisfactionSurveyMessageRecord";
export { default as ScheduledBlockRecordCreator, ScheduledBlockRecord } from "./ScheduledBlockRecord";
export { default as ScheduledCallbackMessageRecord } from "./ScheduledCallbackMessageRecord";
export { default as SecureNuanceLiveAgentMessageRecord } from "./SecureNuanceLiveAgentMessageRecord";
export { default as ShopifyMessageRecord } from "./ShopifyMessageRecord";
export { default as MagentoMessageRecord } from "./MagentoMessageRecord";
export { default as ShuffleMessageRecord } from "./ShuffleMessageRecord";
export { default as TextMessageRecord } from "./TextMessageRecord";
export { default as UnsupportedMessageRecord } from "./UnsupportedMessageRecord";
export { default as VariableOverrideMessageRecord } from "./VariableOverrideMessageRecord";
export { default as VideoMessageRecord } from "./VideoMessageRecord";
export { default as WebWindowMessageRecord } from "./WebWindowMessageRecord";
export { default as WidgetMessageRecord } from "./WidgetMessageRecord";
export { default as ZendeskChatHandoverRecord } from "./ZendeskChatHandoverRecord";
export { default as ZendeskHandoffMessageRecord } from "./ZendeskHandoffMessageRecord";
export { default as ZendeskLiveAgentMessageRecord } from "./ZendeskLiveAgentMessageRecord";
export { default as ZendeskLiveHandoffMessageRecord } from "./ZendeskLiveHandoffMessageRecord";
export { default as ZendeskAgentWorkspaceHandoffMessageRecord } from "./ZendeskAgentWorkspaceHandoffMessageRecord";

export type MessageRecord = (
  AuthMessageRecord |
  ConditionalMessageRecord |
  DeauthMessageRecord |
  ScheduledBlockRecord |
  TextMessageRecord |
  ZendeskAgentWorkspaceHandoffMessageRecord
)
